import { Link, useParams } from "react-router-dom";
import usePermissions from "datasets/hooks/usePermissions";
import { Plus } from "lucide-react";
import { Button } from "~/components/ui/button";
import { TabHeader } from "~/pages/manifold-nextgen/components/TabHeader";
import { DatasetTableList } from "./tables/DatasetTableList";

export const DatasetTables = () => {
  const { datasetId } = useParams<{ datasetId: string }>();
  const canCreate = usePermissions("create:catalog-ingest");

  return (
    <div className="mx-auto flex w-full max-w-4xl flex-col gap-4">
      <TabHeader
        title="Tables"
        action={
          canCreate && (
            <Button
              asChild
              variant="ghost"
              size="sm"
              className="text-primary hover:text-primary/80"
            >
              <Link to={`/nextgen/datasets/${datasetId}/tables/new`}>
                <Plus />
                Add Table
              </Link>
            </Button>
          )
        }
      />
      <DatasetTableList />
    </div>
  );
};
